import { AttributeType } from "@/pages/CaseDetail/Configuration/Attributes/type";

export enum CustomAttributeFormats {
  None = "None",
  SIN = "SIN",
  Email = "Email",
  Phone = "Phone",
  Regex = "Regex",
  Postal = "Postal",
  Integer = "Integer",
  Decimal = "Decimal",
}

export type picklistDefinitions = {
  id: string;
  name: string;
  nameFrench: string;
  displayOrder: number;
};
export interface CustomAttributeProps {
  customAttributeDetails: {
    metadataJSON?: {
      default?: string;
      minimum?: string;
      maximum?: string;
      fileFormat?: string;
      maskInput?: boolean;
      maxCharacter?: string;
      format?: CustomAttributeFormats;
      warningMessage?: string;
      regexPattern?: string;
    };
    picklistDefinitions?: picklistDefinitions[];
    name: string;
    isRequired: boolean;
    description: string;
  };
  customAttributeType: AttributeType;
  attributeValue: any;
  setAttributeValue: (value: any) => void;
  index: number;
  disabled?: boolean;
  setIntialAttributesValue?: (value: any) => void;
  errorFields?: string[];
  setErrorFields?: (value: string[]) => void;
  showAttributesWithValue?: boolean;
  variant?: "create" | "edit";
}
